import {DeliveryOrder} from 'app/blocks/model/delivery-order.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IDeliveryOrder} from 'app/blocks/model/delivery-order.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class DeliveryOrderService extends EntityCrudService<IDeliveryOrder> {
    constructor(http: HttpClient) {
        super(http, Resource.DELIVERY_ORDERS, (obj?) => new DeliveryOrder(obj));
    }
}
